<div class="modal-size" role="dialog">
  <gstar-header-modal
    [id]="modalId"
    (cancel)="closeHandler()"
    [title]="'admin.dashboard.exportCountriesInformation' | translate" />
  <gstar-body-modal>
    <p>
      {{ 'admin.dashboard.exportCountriesInformationConfirmation' | translate }}
    </p>
    @if (isLoading()) {
      <p class="ap-pt-spacing-2" style="color: var(--color-neutral-500)">
        {{ 'admin.dashboard.exportCountriesInformationLoading' | translate }}
      </p>
    }
  </gstar-body-modal>
  <gstar-footer-modal
    [id]="modalId"
    (confirmEvent)="confirm()"
    (cancelEvent)="closeHandler()"
    [isEnabled]="!isLoading()" />
</div>
